module.exports = __webpack_public_path__ + "static/media/plan.15e8a79e.svg";